import { matrixBoxPlot } from 'ml-spectra-processing';
export function getBoxPlotData(normalizedData) {
    return {
        x: normalizedData.x,
        ...matrixBoxPlot(normalizedData.matrix),
    };
}
//# sourceMappingURL=getBoxPlotData.js.map